/**
 * Saisie d'un montant au pave numerique, comme sur une caisse : les chiffres
 * entrent par la droite, en cents (1, 0, 0, 0, 0 -> 100,00 $). « 00 » ajoute
 * deux zeros, ⌫ retire le dernier chiffre. Au-dela du plafond, la touche est
 * ignoree (le montant ne change pas).
 */

/**
 * @param {number} cents montant actuel
 * @param {string} chiffres '0' a '9' ou '00'
 * @param {number} max plafond en cents
 */
export function ajouterChiffres(cents, chiffres, max) {
    if (!/^\d{1,2}$/.test(chiffres)) return cents;
    const next = Number(`${cents}${chiffres}`);
    return Number.isSafeInteger(next) && next <= max ? next : cents;
}

/** Retire le dernier chiffre saisi. */
export function effacerChiffre(cents) {
    return Math.floor(cents / 10);
}
